const feature = {};

Object.defineProperty(feature, 'Sc18854', { value: '18854-add-ability-to-set-custom-attributes-on-hum-iframe', writable: false });
Object.defineProperty(feature, 'Sc25576', { value: '25576-disable-storage-listener-for-get-visitor-id', writable: false });
Object.defineProperty(feature, 'Sc24936', { value: '24936-customize-success-message', writable: false });

export default feature;
